'use strict';

function getVideoUrl(videoId) {
  var baseUrlPrefix = 'https://www.youtube.com/watch?v=';
  return baseUrlPrefix + videoId;
}

function getVideoIdFromUrl(url) {
  // TODO: add support for additional youtube url formats
  // Test for long youtube url: http://youtube.com/watch?[...&]v=[VIDEO_ID]
  var YTLongUrl = /(?:youtube\.com\/watch[^\s]*[\?&]v=)([\w-]+)/g;
  // Test for short youtube url: http://youtu.be/[VIDEO_ID]
  var YTShortUrl = /(?:youtu\.be\/)([\w-]+)/g;

  var match = YTLongUrl.exec(url) || YTShortUrl.exec(url);
  if (match && match.length && match[1]) {
    //if there is a match, the second group is the id we want
    return match[1];
  }
}

module.exports = {
  getVideoUrl: getVideoUrl,
  getVideoIdFromUrl: getVideoIdFromUrl
};


// WEBPACK FOOTER //
// ./~/santa-platform-utils/lib/videoUrlsUtils/youtubeVideoUtils.js